import { render, staticRenderFns } from "./planPurForAutoPur.vue?vue&type=template&id=f1c13154&scoped=true&"
import script from "./planPurForAutoPur.vue?vue&type=script&lang=js&"
export * from "./planPurForAutoPur.vue?vue&type=script&lang=js&"
import style0 from "./planPurForAutoPur.vue?vue&type=style&index=0&id=f1c13154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c13154",
  null
  
)

component.options.__file = "planPurForAutoPur.vue"
export default component.exports